import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { Router,ActivatedRoute } from '@angular/router';
import { RoomSearchService } from '../../room-search/room-search.service';
import { PopupComponent } from '../../dialogs/popup/popup.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'app-giftcard',
  templateUrl: './giftcard.component.html',
  styleUrls: ['./giftcard.component.scss']
})
export class GiftcardComponent implements OnInit {
  public hotel_code:string='manhattantowerfl';
  public gc_data:any={};
  public gc_price;
  public quantity:any = [1,2,3,4,5];
  public selected_quantity:number = 1;
  public selected_gc_price:string = ''; 
  public openPrice:any;
  public showPriceInput:boolean = false;
  private hotelDataSubscription;
  public hotelData;
  public showLoader:boolean = false;
  private hotelsDataSubscription;
  public showHotelDropdown:boolean = false;
  public hotelsData:any;
  constructor(
  	private router: Router,
		private commonService:CommonService,
    private searchService: RoomSearchService,
    private dialog : MatDialog
	) {
			this.hotel_code =this.router.url.split('/')[2];
      if(this.router.url.split('/')[1] === 'hotel'){
        this.hotel_code =this.router.url.split('/')[2];
           this.hotelDataSubscription = this.commonService.particularHotelData.subscribe((hotel:any) => {
          if(hotel.hotel_code != undefined || hotel.hotel_code != ''){
            this.hotelData = hotel;
          }
        });
      } else {
        this.hotel_code = 'manhattantowerfl';
         this.hotelsDataSubscription = this.commonService.HotelsData.subscribe((hotelsData:any)=>{
            this.hotelsData = hotelsData;
            this.showHotelDropdown =true;
          })
      } 
   
  }
  getGiftCard(){
		this.commonService.getGiftCard({'hotel_code':this.hotel_code}).then((response:any)=>{
      if(response.status === 'success'){
        this.gc_data = response.data;
        this.gc_price = this.gc_data.p_gc_price_opt.split(',');
        if(this.gc_data.p_gc_open_price === '1'){
          this.gc_price.push('Other Amount ...');
        }
        this.selected_gc_price = this.gc_price[0];
        this.openPrice = parseInt(this.gc_data.p_gc_open_price_min);
      }
		});    
  }

  // keyPress(event: any) {
  //   const pattern = /[0-9.]/;
  //   const inputChar = String.fromCharCode(event.charCode);

  //   if (!pattern.test(inputChar)) { // invalid character, prevent input || pattern.test(inputChar) 
  //     event.preventDefault();
  //   }
  // }
  checkSelection(){
    if(this.selected_gc_price === 'Other Amount ...'){
      this.showPriceInput = true;
    } else {
      this.showPriceInput = false;
    }
  }
  checkprice(){
    if(!(parseInt(this.openPrice) >= parseInt(this.gc_data.p_gc_open_price_min) && parseInt(this.openPrice) <=parseInt(this.gc_data.p_gc_open_price_max))){
      this.openPrice = parseInt(this.gc_data.p_gc_open_price_max);
    }
  }
  addToCart(){
      this.showLoader = true;
   
    let reservationInfo:any = {
      'p_gc_price_opt':this.gc_data.p_gc_price_opt,
      'p_gc_open_price':this.gc_data.p_gc_open_price,
      'p_gc_open_price_min':this.gc_data.p_gc_open_price_min,
      'p_gc_open_price_max':this.gc_data.p_gc_open_price_max,
      'media':this.gc_data.media,
      'tax_id':this.gc_data.tax_id,
      'tax_name':this.gc_data.tax_name,
      'tax_value':this.gc_data.tax_value,
      'productId':this.gc_data.product_id,
      'roomTypeName':this.gc_data.product_name,
      'mupog':'',
      'cart_type' : 'gift_card',
      'quantity' : this.selected_quantity,
      'nightlySum' :''
    };
     if(this.showPriceInput){
      reservationInfo.nightlySum = parseInt(this.openPrice);
    } else {
      reservationInfo.nightlySum = parseInt(this.selected_gc_price); 
    }
    if(localStorage.getItem('mupog') !== undefined && localStorage.getItem('mupog') !== null && localStorage.getItem('mupog') !== ''){
      reservationInfo.mupog = localStorage.getItem('mupog');
    }
    this.searchService.addToCart(reservationInfo).then((data:any) => {
        if(data.status == 'error'){
          this.showLoader =false;
          this.openDialog({'message':data.message,'title':data.status.toUpperCase()});
        } else {
            setTimeout(()=>{
              let cartData = data.data.cart_data;
              let cartTotal = data.data.cart_total;
              var totalCartItems = 0;
              cartData.forEach((value,index)=>{
                totalCartItems += parseInt(value.service_quantity);
              });
              localStorage.setItem('mupog',data.data.cart_data[0].mupog);
              this.commonService.updateCartData(totalCartItems);
              this.commonService.updateCartItems(cartData);
              this.commonService.updateCartItemsTotal(cartTotal);
              this.commonService.updateshowCart(true);
              this.showLoader =false;
            },100);
        }
    });
  }

  ngOnInit() {
    this.getGiftCard();
  }

    /**************************
  *To Show Error  dialog box*
  **************************/
  openDialog(data): void {
    const dialogRef = this.dialog.open(PopupComponent, {
      width: '600px',
      data: data,
       panelClass: 'mlspopblock'
    });

    dialogRef.afterClosed().subscribe(res => {
      
    });
  }
}
